<template>
  <div class="bt" :class="{ 'search-students': searchKey }">
    <div class="search-con fb fb-col width-full height-full">
      <common-search
        ref="commonSearch"
        :searchKey.sync="searchKey"
        :show-select="showSelect"
        :appoint-role="appointRole"
        :only-class="true"
        :placeholder="placeholder"
      ></common-search>
      <div v-if="searchKey && !showSlot" class="item-flex-1 h-0 scroll">
        <div
          v-if="!searchPeopleList.length"
          class="height-full fb fb-cross-center fb-main-center font-34 c-171A1D-40"
          >{{ searchMsg }}</div
        >
        <div v-else>
          <div
            class="bg-FFFFFF p-0-16"
            @click="handlerClick(item)"
            v-for="(item, index) in searchPeopleList"
            :key="item.memberId"
          >
            <template v-if="item.memberId">
              <div class="fb fb-main-between fb-cross-center h-64">
                <div class="pr-12 fb fb-main-between fb-cross-center">
                  <div
                    class="tree-name font-28 fb fb-main-center fb-cross-center c-FFFFFF"
                  >
                    <span>{{ item.memberName.slice(0, 2) }}</span>
                  </div>
                </div>
                <div
                  class="item-flex-1 fb fb-main-start fb-cross-center pr-16 height-full"
                  :class="{
                    'bb-111F2C-12': index < searchPeopleList.length - 1
                  }"
                >
                  <div class="item-flex-1">
                    <div class="c-171A1D lh-24">{{ item.memberName }}</div>
                    <div class="font-28 c-171A1D-40 lh-20">{{
                      item.deptName
                    }}</div>
                  </div>
                  <div
                    class="w-84 c-171A1D-40 fb fb-main-start fb-cross-center"
                  >
                    <div v-if="!item.identityStatus && !searchKey">待完善</div>
                    <i class="iconfont">&#xe68d;</i>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div v-if="showSlot" class="slot item-flex-1 h-0 scroll">
        <slot name="detail"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import commonSearch from './commonSearch'
import { mcShowPreloader, mcHidePreloader } from '@/utils/mcSdkUtils'
import API from '@/api'
import mixin from '../mixin'
export default {
  mixins: [mixin],
  components: { commonSearch },
  props: {
    placeholder: {
      type: String,
      default: '搜索姓名'
    },
    showNoData: {
      type: Boolean,
      default: true
    },
    liveInOnly: {
      type: Boolean,
      default: false
    },
    showSelect: {
      type: Boolean,
      default: false
    },
    // 0 德育 1 考评
    teacherType: {
      type: Number,
      default: -1
    },
    // 搜索在哪个模块使用  moral-德育、attendance-考勤、dorm-宿舍
    usedModule: {
      type: String,
      required: true
    },
    // 与 usedModule 配合使用，自行调整角色列表范围
    accessList: {
      type: Array,
      default: () => []
    },
    appointRole: {
      type: [Number, String],
      default: 0
    },
    propsDingDeptIds: {
      type: String,
      default: ''
    },
    // 点击完成是否清除数据
    clearOnClick: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      wait: 300, // 防抖时间默认为0.3s
      searchKey: '',
      searchPeopleList: [],
      searchMsg: '',
      showSlot: false
    }
  },
  watch: {
    searchKey(v) {
      this.$emit('update:searchKey', v)
      this.showSlot = false
      if (v !== '') {
        this.searchDebounce(this.getMembersByKey, this.wait)()
      } else {
        this.searchPeopleList = []
        this.searchMsg = ''
      }
    }
  },
  computed: {
    query() {
      return this.$route.query || {}
    },
    roleType() {
      return +this.query.role || this.currentMixinRole
    }
  },
  methods: {
    handlerClick(item) {
      this.$emit('click', item)
      this.clearOnClick && this.clearSearchKey()
    },
    clearSearchKey() {
      try {
        this.$refs.commonSearch.handlerToClearSearchKey()
      } catch (error) {}
    },
    // 搜索
    searchDebounce(func, wait) {
      let _that = this
      // eslint-disable-next-line space-before-function-paren
      return function () {
        let context = this
        let args = arguments
        if (_that.timeout) clearTimeout(_that.timeout)
        _that.timeout = setTimeout(() => {
          func.apply(context, args)
        }, wait)
      }
    },
    // 按名字查询人
    getMembersByKey() {
      if (this.searchKey === '') {
        return
      }
      mcShowPreloader()
      API.searchOrgMember({
        memberName: this.searchKey,
        operUserRoleTypes: this.currentRole
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            return false
          }
          this.searchMsg = res.length ? '' : '没有搜索到相关结果'
          this.searchPeopleList = res || []
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
        .finally(_ => mcHidePreloader())
    },
    handlerToShowSlot() {
      this.showSlot = true
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.search-students {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.bb-111F2C-12 {
  border-bottom: 1px solid rgba(17, 31, 44, 0.12);
}
.tree-name {
  background: #006afe;
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
</style>
